import styled from "styled-components"

export const Wrapper = styled.main`
  width: 100%;
  flex: 1 1 0%;
`
